<template>
  <div v-show="showBegin">
    <div class="beginImg"><img src="/wall/begin.png" alt="" width=1460 height=800 ></div>
    <el-row style="position:absolute; left:25%; top:30px;" :gutter="20"  >
      <el-col span="4" >
        <span class="beginText">请选择试卷模板:</span>
      </el-col>
      <el-col class="select" span="3" >
        <el-select  v-model="busData.templateId" size="large" placeholder="试卷模板" no-data-text="当前无考试模板">
          <el-option v-for="item in busData.templateList"  :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-col>
      <el-col class="button" span="3" >
        <el-button  @click="begin(busData.templateId)" type="primary" size="large">开始考试</el-button>
      </el-col>
    </el-row>
  </div>
  <div v-show="showExam" class="answer">
    <div class="top">
      <ul class="index">
        <li>{{busData.name}}</li>
        <li>倒计时：{{count}}</li>
      </ul>
    </div>
    <div v-show="showPass">
      <div class="pass"><span>恭喜考生{{busData.create_user_name}} ， 您获得的分数是:{{busData.score}}</span></div>
      <div class="passImg"><img src="/wall/pass.png" alt="" width="1440" height="448"></div>
    </div>
    <div v-show="showDefeat">
      <div class="defeat"><span>考生{{busData.create_user_name}} ， 您获得的分数是:{{busData.score}}</span></div>
      <div class="defeatImg"><img src="/wall/defeat.png" alt="" width="1440" height="448"></div>
    </div>
    <div v-show="showPaper">
      <div class="flexArea">
        <!--左边题目编号区-->
        <div class="left">
          <div class="l-bottom">
            <div class="item">
              <p class="total_score"><b>总分:{{ busData.total_score }}</b></p>
              <p class="pass_score"><b>及格:{{ busData.pass_score }}</b></p>
            </div>
          </div>
          <ul class="l-top">
            <li>
              <a href="javascript:"></a>
              <span>未答</span>
            </li>
            <li>
              <a href="javascript:"></a>
              <span>已答</span>
            </li>
          </ul>
          <div class="l-bottom">
            <div class="item">
              <div>
                <el-row>
                  <ul>
                    <li v-for="(item, index) in busData.itemList" :key="item.id">
                      <el-button v-if="!item.answer && index !== this.page" class="unAlready"
                                 @click="goToProblem(index)">{{ index + 1 }}
                      </el-button>
                      <el-button v-if="item.answer && index !== this.page" class="already"
                                 @click="goToProblem(index)">{{ index + 1 }}
                      </el-button>
                      <el-button v-if="!item.answer && index === this.page" class="unAlready_now"
                                 @click="goToProblem(index)">{{ index + 1 }}
                      </el-button>
                      <el-button v-if="item.answer && index === this.page" class="already_now"
                                 @click="goToProblem(index)">{{ index + 1 }}
                      </el-button>
                    </li>
                  </ul>
                </el-row>
              </div>
            </div>
            <div class="final" type="text" @click="ahead">结束考试</div>
          </div>
        </div>
        <!--右边选择答题区-->
        <el-card class="right">
          <div v-for="(item,index) in busData.itemList" :key="item.id" class="content">
            <div v-if="index === page">
              <div class="single" v-if="item.question_type === 'single'">
                <div>
                  <ul class="topic">
                    <li><span class="orderNumber">{{ index + 1 }}</span></li>
                    <li><span class="question_typeSingle">单选题</span></li>
                    <li><span class="score">( {{ item.score }} 分 )</span></li>
                  </ul>
                </div>
                <div class="tip"><p>{{ item.topic }}</p></div>
                <div class="image" v-if="item.picture != null">
                  <el-image v-for="(file,index) in item.fileList" :key="index" style="width: 100px; height: 100px"
                            :src="file.url" :preview-src-list="[file.url]"></el-image>
                </div>
                <el-radio-group v-model="item.answer" class="choice" size="large" @change="putAnswer(item)">
                  <el-radio v-if="item.option_a" :label="'option_a'"><span
                      style="font-size: 18px">A. {{ item.option_a }}</span></el-radio>
                  <el-radio v-if="item.option_b" :label="'option_b'"><span
                      style="font-size: 18px">B. {{ item.option_b }}</span></el-radio>
                  <el-radio v-if="item.option_c" :label="'option_c'"><span
                      style="font-size: 18px">C. {{ item.option_c }}</span></el-radio>
                  <el-radio v-if="item.option_d" :label="'option_d'"><span
                      style="font-size: 18px">D. {{ item.option_d }}</span></el-radio>
                  <el-radio v-if="item.option_e" :label="'option_e'"><span
                      style="font-size: 18px">E. {{ item.option_e }}</span></el-radio>
                  <el-radio v-if="item.option_f" :label="'option_f'"><span
                      style="font-size: 18px">F. {{ item.option_f }}</span></el-radio>
                </el-radio-group>
              </div>
              <div class="fill" v-if="item.question_type === 'multiple'">
                <div>
                  <ul class="topic">
                    <li><span class="orderNumber">{{ index + 1 }}</span></li>
                    <li><span class="question_typeFill">多选题</span></li>
                    <li><span class="score">( {{ item.score }} 分 )</span></li>
                  </ul>
                </div>
                <div class="tip"><p>{{ item.topic }}</p></div>
                <div class="image" v-if="item.picture != null">
                  <el-image v-for="(file,index) in item.fileList" :key="index" style="width: 100px; height: 100px"
                            :src="file.url" :preview-src-list="[file.url]"></el-image>
                </div>
                <el-checkbox-group v-model="item.answer" class="choice" size="large" @change="putAnswer(item)">
                  <el-checkbox v-if="item.option_a" :label="'option_a'"><span
                      style="font-size: 18px">A. {{ item.option_a }}</span></el-checkbox>
                  <el-checkbox v-if="item.option_b" :label="'option_b'"><span
                      style="font-size: 18px">B. {{ item.option_b }}</span></el-checkbox>
                  <el-checkbox v-if="item.option_c" :label="'option_c'"><span
                      style="font-size: 18px">C. {{ item.option_c }}</span></el-checkbox>
                  <el-checkbox v-if="item.option_d" :label="'option_d'"><span
                      style="font-size: 18px">D. {{ item.option_d }}</span></el-checkbox>
                  <el-checkbox v-if="item.option_e" :label="'option_e'"><span
                      style="font-size: 18px">E. {{ item.option_e }}</span></el-checkbox>
                  <el-checkbox v-if="item.option_f" :label="'option_f'"><span
                      style="font-size: 18px">F. {{ item.option_f }}</span></el-checkbox>
                </el-checkbox-group>
              </div>
              <div class="judge" v-if="item.question_type === 'judge'">
                <div>
                  <ul class="topic">
                    <li><span class="orderNumber">{{ index + 1 }}</span></li>
                    <li><span class="question_typeJudge">判断题</span></li>
                    <li><span class="score">( {{ item.score }} 分 )</span></li>
                  </ul>
                </div>
                <div class="tip"><p>{{ item.topic }}</p></div>
                <div class="image" v-if="item.picture != null">
                  <el-image v-for="(file,index) in item.fileList" :key="index" style="width: 100px; height: 100px"
                            :src="file.url" :preview-src-list="[file.url]"></el-image>
                </div>
                <el-radio-group v-model="item.answer" class="choice" size="large" @change="putAnswer(item)">
                  <el-radio :label="'correct'"><span style="font-size: 18px">是</span></el-radio>
                  <el-radio :label="'fault'"><span style="font-size: 18px">否</span></el-radio>
                </el-radio-group>
              </div>
              <div class="operation">
                <ul class="end">
                  <li @click="previous()" v-if="index !== 0" :class="index === 1 ? 'next' : 'before-next'">
                    <span>上一题</span></li>
                  <li @click="toNext()" v-if="index !== busData.itemList.length-1"
                      :class="index === 0 ? 'next' : 'before-next'">
                    <span>下一题</span></li>
                </ul>
              </div>
            </div>
          </div>
        </el-card>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name:"ExamDetail",
  inject: ['$fn'],
  props: {
    params: {
      type: Object,
      default: () => {
        return {}
      }
    },
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return {
      //倒计时
      count:'',
      //倒计时总秒数
      seconds:'',
      //页数
      page: 0,
      //全局index
      index: 0,
      title: "请选择正确的选项",
      itemId: '',
      busData: {
        //总分
        total_score: 0,
        time: '',
        name: '',
        //合格分数
        pass_score:'',
        create_user_id:'',
        create_user_name:'',
        remark: '',
        //得分
        score:'',
        id: '',
        itemList: '',
        templateId:'',
        templateList:[],
        //离开界面次数
        outNumber:0,
        //剩余考试时间
        seconds:'',
        //考试状态
        status:"未完成"
      },
      //试卷信息
      item: {
        option_a:'',
        option_b:'',
        option_c:'',
        option_d:'',
        option_e:'',
        option_f:'',
        topic:''
      },
      //题号
      orderNumber: 0,
      //答案
      answer:'',
      //初始选择模板界面，默认显示
      showBegin:true,
      //显示考试主要界面，默认显示
      showPaper: true,
      //展现考试通过页面,默认不显示
      showPass: false,
      //展现考试失败页面，默认不显示
      showDefeat:false,
      //显示考试界面顶端以及考试主要界面，默认不显示
      showExam:false,

    }
  },
  created() {
    this.getTemplate()
    this.busData.templateId = ''
  },
  methods: {
    //获取试卷模板列表
    async getTemplate(){
      this.busData.templateList = await this.$http('ihtExamService.getExamTemplateAll')
    },

    toNext() { //下一题
      // 索引+1；
      this.index ++;
      // page ++
      this.page ++;
    },

    previous() { //上一题
      this.index --;
      this.page --;
    },

    goToProblem(index){ //跳转到指定题目
      this.index = index+1;
      this.page = index;
    },

    //根据试卷模板具体信息去抽取题目
    async getExamAnswerWithDetail(templateId) {
      console.log("templateId-=",templateId)
      let params = {templateId:templateId}
      let examData = await this.$http('ihtExamService.getExamAnswerWithDetail', params)
      this.busData.id = examData.id
      this.busData.name = examData.name
      this.busData.time = examData.time
      this.busData.pass_score = examData.pass_score
      this.busData.total_score = examData.total_score
      this.busData.remark = examData.remark
      this.busData.create_user_id = examData.create_user_id
      this.busData.create_user_name = await this.$http('ihtExamService.getExamPerson', this.busData)
      this.busData.itemList = examData.itemList || [];
      this.busData.seconds = this.busData.time * 60

    },

    //显示倒计时
    countDown(){
      let h = parseInt(this.busData.seconds / (60 * 60) % 24);
      h = h < 10 ? "0" + h : h
      let m = parseInt(this.busData.seconds / 60 % 60 );
      m = m < 10 ? "0" + m : m
      let s = parseInt(this.busData.seconds % 60 );
      s = s < 10 ? "0" + s : s
      this.count = h + '时' + m + '分' + s + '秒'
    },

    mounted() {
      // 启动计时器，每秒更新count值
      this.timer = setInterval(() => {
        if (this.busData.seconds > 0) {
          this.busData.seconds--;
          this.$http('ihtExamService.putSeconds', this.busData)
          this.countDown()
          if(this.busData.seconds === 600) {
            this.$message({
              showClose: true,
              type: 'error',
              message: '考生注意,考试时间还剩10分钟！！！'
            })}
          if(this.busData.seconds === 60) {
            this.$message({
              showClose: true,
              type: 'error',
              message: '考生注意,考试时间还剩1分钟！！！时间结束将自动交卷'
            })}
        } else {
          clearInterval(this.timer); // 倒计时结束，停止计时器
          this.over();
        }
      },1000);
    },

    //选择试卷模板开始考试
    begin(templateId){
      console.log("templateId-=",templateId)
      if(!templateId){
        return this.$message.error('请选择试卷模板');
      }
      this.getExamAnswerWithDetail(templateId).then(data =>{
            this.mounted()
          }
      );
      this.showBegin = !this.showBegin;
      this.showExam = !this.showExam;
      this.monitor()

    },

    //自动保存答案
    putAnswer(item){
      this.$http('ihtExamService.putAnswer', item)
    },

    //交卷计算分数，跳转界面
    async over(){
      this.busData.status = "已完成"
      this.busData.score = await this.$http('ihtExamService.getScoreSum', this.busData)
      this.$message.success("交卷成功");
      clearInterval(this.timer);
      if(this.busData.score >= this.busData.pass_score){
        this.showPaper = !this.showPaper;
        this.showPass = !this.showPass;//使false变为true显示
      } else {
        this.showPaper = !this.showPaper;
        this.showDefeat = !this.showDefeat //使false变为true显示
      }
    },

    //提前交卷弹框提醒
    ahead() {
      this.$confirm('您是否要提前结束考试', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.over();
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消提交'
        });
      });
    },

    //切出页面报提醒，防止作弊
    monitor(){
      document.body.onblur = () => {
        if(this.busData.status === "未完成"){
          this.busData.outNumber++;
          this.$http('ihtExamService.putOutNumber', this.busData)
          if (this.busData.outNumber === 1){
            alert(`请回到考试界面，你已离开${this.busData.outNumber}次，后续将不再弹出提醒，但会依然记录切出页面次数`)
          }
        }
      }
    },
  },

}
</script>

<style scoped lang="less">

.operation .end li {
  cursor: pointer;
  margin: 0 50px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: rgba(53, 150, 220, 0.99);
  border-radius: 5px;
  width: 100px;
  height: 40px;
  color: #fff;
}
.operation {
  background-color: #fff;
  border-radius: 4px;
  padding: 30px;
  margin-right: 10px;
}
.operation .end {
  display: flex;
  align-items: center;
  color: rgb(39, 118, 223);
}

.content .topic {
  display: inline-flex;
  align-items:center;
}

.topic .orderNumber {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 30px;
  background-color: rgb(39, 118, 223);
  color: #fff;
  border-radius: 4px;
  margin-right: 4px;
  font-size: 35px;
}

.topic .question_typeSingle {
  padding: 0 5px 0 5px;
  color: #409eff;
  background-color: #d9ecff;
  font-size: 22px;
}

.topic .question_typeFill {
  padding: 0 5px 0 5px;
  color: #e6a23c;
  background-color: #faecd8;
  font-size: 22px;
}

.topic .question_typeJudge {
  padding: 0 5px 0 5px;
  color: #67c23a;
  background-color: #f0f9eb;
  font-size: 22px;
}

.topic .score{
  margin-left: 4px;
  font-size: 25px;
}

.right .content {
  margin: 0;
}

.choice{
  margin-left: 30px;
}

.content .el-radio-group {
  display: flex;
  flex-direction:column;
}

.content .el-radio-group el-radio {
  margin-left: 10px;
}

.content .el-checkbox-group{
  display: flex;
  flex-direction:column;
}

.el-radio-group {
  display: inline-flex;
  align-items: flex-start;
  flex-wrap: wrap;
  font-size: 0;
}

.tip p{
  margin: 5px;
  font-size: 20px;
  text-align: left;
  -webkit-user-select:none;
  -moz-user-select:none;
  -ms-user-select:none;
  user-select:none;
}

.right .title p {
  display: flex;
  margin-top: 0;
  background-color: #fff;
  height: 50px;
  line-height: 50px;
  margin-left: 10px;
  font-size: 20px;
}

.flexArea {
  display: flex;
}

.flexArea .right {
  flex: 1;
}

.right .title span {
  font-size: 20px;
}

.right .title {
  margin-right: 30px;
  padding-right: 40px;
  display: flex;
  margin-top: 10px;
  background-color: #fff;
  height: 50px;
  line-height: 50px;
}

.pass {
  font-size: 30px;
  margin: 50px 0 0 10px;
  text-align: center;
}

.defeat {
  font-size: 30px;
  margin: 50px 0 0 10px;
  text-align: center;
}

.beginImg {
  margin: 30px;
  text-align: center;
}
.passImg {
  margin: 30px 0 0 0;
  text-align: center;
}

.defeatImg {
  margin: 30px 0 0 0;
  text-align: center;
}

.begin {
  text-align: center;
}
.beginText{
  font-size: 30px;
}
.select {
  font-size: 27px;
}

.select el-select{
  color: #0a84ff;
}

.button {
  font-size: 27px;
}

.l-bottom .final {
  cursor: pointer;
  display: inline-block;
  text-align: center;
  background-color: rgb(39, 118, 223);
  width: 200px;
  margin: 5px 0 10px 22px;
  border-radius: 4px;
  height: 30px;
  line-height: 30px;
  color: #fff;
}

.left {
  width: 260px;
  height: 100%;
  margin: 10px 10px 0 10px;
}

.left .l-top {
  display: flex;
  justify-content: space-around;
  padding: 10px 0 2px 2px;
  border: #fff;
  margin-top: 5px;
  border-radius: 4px;
  background-color: #fff;
  box-shadow: 0 0 5px -3px rgba(0,0,0,5);
}

.left .l-top li {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.left .l-top li a {
  padding: 12px;
  background-color: #fff;
  border: 1px solid #394850;
  border-radius: 50%;
}

.left .l-top li:nth-child(2) a {
  background-color: rgb(39, 118, 223);
  padding: 13px;
  border: none;
  border-radius: 50%;
}

.answer .left .item {
  padding: 0;
  font-size: 16px;
}

.l-bottom {
  padding: 10px 0 2px 2px;
  margin: 5px 5px 0 5px;
  background-color: #fff;
  box-shadow: 0 0 5px -3px rgba(0,0,0,5);
}

.l-bottom .item {
  display: inline-block;
  background-color: #fff;
  flex-direction: column;
}

.l-bottom .item .total_score {
  margin-bottom: 8px;
  color: #4c8adc;
  display: inline-block;
  margin-left: 10px;
  letter-spacing: 2px;
  font-size: 20px;
}

.l-bottom .item .pass_score {
  margin-bottom: 8px;
  color: #4c8adc;
  display: inline-block;
  margin-left: 30px;
  letter-spacing: 2px;
  font-size: 20px;
}

.l-bottom .item .listing {
  margin-bottom: 8px;
  color: #000;
  margin-left: 10px;
  letter-spacing: 2px;
}

.l-bottom .item ul {
  width: 100%;
  background-color: #fff;
  display: flex;
  flex-wrap: wrap;
}

.l-bottom .item li {
  margin-left: 8px;
  margin-bottom: 10px;
}

.l-bottom .item ul li {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #fff;
  text-align: center;
}

.already{
  width: 35px;
  height: 35px;
  background-color:rgb(39, 118, 223);
  display: inline-block;
  padding: 10px;
  border-radius: 50%;
  color: #fff;
  justify-content: center;
  align-items: center;
  text-align: center;
}
.already_now{
  width: 39px;
  height: 39px;
  background-color:rgb(39, 118, 223);
  display: inline-block;
  padding: 10px;
  border-radius: 50%;
  border-color: #fd0303;
  border-width: 3px;
  color: #fff;
  justify-content: center;
  align-items: center;
  text-align: center;
}
.unAlready{
  width: 35px;
  height: 35px;
  display: inline-block;
  padding: 10px;
  border-radius: 50%;
  background-color: #fff;
  border: 1px solid #394850;
  justify-content: center;
  align-items: center;
  text-align: center;
}
.unAlready_now{
  width: 39px;
  height: 39px;
  display: inline-block;
  padding: 10px;
  border-radius: 50%;
  border-color: #fd0303;
  border-width: 3px;
  background-color: #fff;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.answer .top .index {
  display: flex;
  justify-content:space-between;
  color: #fff;
  padding: 20px;
  font-size: 22px;
}

.answer .top .index li {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.right .topic li {
  display: flex;
  align-items: center;
  padding: 0 0 0 5px;
}

.answer .top {
  background-color: rgb(54, 106, 175);
}

.answer {
  padding-bottom: 30px;
}

</style>
